<script setup>
import {defineProps, computed, ref} from 'vue'

const props = defineProps(["data"])

const imageLoadError = ref(false)

function generateThumbnail(name) {
  const colors = ['#10B981', '#3B82F6', '#8B5CF6', '#F59E0B', '#EF4444', '#06B6D4']
  const colorIndex = name ? name.charCodeAt(0) % colors.length : 0
  const color = colors[colorIndex]
  const initial = name ? name.charAt(0).toUpperCase() : '?'
  return { color, initial }
}

// Handle both string (name) and object (provider with thumbnail_url) data
const providerData = computed(() => {
  if (typeof props.data === 'string') {
    return { name: props.data, thumbnail_url: null }
  }
  return props.data || { name: '', thumbnail_url: null }
})

const thumbnail = generateThumbnail(providerData.value.name)

const handleImageError = () => {
  // When image fails to load, show fallback
  imageLoadError.value = true
}

// Show thumbnail image only if URL exists and hasn't failed to load
const showThumbnailImage = computed(() => {
  return providerData.value.thumbnail_url && !imageLoadError.value
})
</script>

<template>
  <div class="provider-thumbnail-container">
    <!-- Show thumbnail image if available and loaded successfully -->
    <img
      v-if="showThumbnailImage"
      :src="providerData.thumbnail_url"
      :alt="providerData.name"
      class="provider-thumbnail-image"
      @error="handleImageError"
    />
    <!-- Fallback to colored initial -->
    <div
      v-else
      class="provider-thumbnail"
      :style="{ backgroundColor: thumbnail.color }"
    >
      {{ thumbnail.initial }}
    </div>
  </div>
</template>

<style scoped>
.provider-thumbnail-container {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.provider-thumbnail {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  font-size: 0.8rem;
}

.provider-thumbnail-image {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
